import { render } from "./ProductFormular.vue?vue&type=template&id=63b09bfb"
import script from "./ProductFormular.vue?vue&type=script&lang=js"
export * from "./ProductFormular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__